module.exports = __webpack_public_path__ + "img/fun3.10966ca8.png";